import { Injectable } from '@angular/core';
import { UserI} from '../../pages/admin/interfaces/user.interface';
import { Observable, Observer } from 'rxjs';
import { ApiService } from '../services/api.service';
import { RouterService } from '../services/router.service';
import { StorageService } from '../services/storage.service';
import { AuthData } from './interfaces/auth-data.interface';
import { Credentials } from './interfaces/credentials.interface';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public state = {
    error: null,
    maintenance: null
  };
  public user: UserI;
  public authed = false;
  public authChecked = false;
  private accessToken: string;
  public expiresAt: Date;
  private authCBs: ((auth: boolean) => void)[] = [];
  public authObserver: Observer<boolean>;
  public authObservable: Observable<boolean>;
  public authType: string = 'oidc';

  constructor(
    public storage: StorageService,
    public api: ApiService,
    public router: RouterService,
  ) {

    this.authObservable = new Observable((observer) => {
      this.authObserver = observer;
    });

    this.authObservable.subscribe((auth: boolean) => {
      this.authed = auth;
      for (const cb of this.authCBs) {
        cb(auth);
      }
    });

    this.storage.get('auth-data').then((authData: AuthData) => {
      // console.log(authData);

      if (authData) {
        this.user = authData.user;
        this.expiresAt = new Date(authData.expiresAt);
        this.accessToken = authData.accessToken;
        this.authType = authData.authType;
        if ((new Date()).getTime() > this.expiresAt.getTime()) {
          delete this.user;
          delete this.accessToken;
          delete this.expiresAt;
          this.storage.remove('auth-data');
          this.authObserver.next(false);
          this.router.navigateByUrl('/');
        } else {
          this.authObserver.next(true);
        }
      } else {
        this.authObserver.next(false);
        this.router.navigateByUrl('/');
      }

      this.authChecked = true;
    });
  }

  public getToken(): string {
    return this.accessToken;
  }

  public async auth(credentials: Credentials): Promise<boolean> {
    // credentials.password = this.hash(credentials.password);
    const authData = await this.api.post('admin/auth', credentials) as AuthData;
    this.user = authData.user;
    this.accessToken = authData.accessToken;
    this.authType = authData.authType;
    this.expiresAt = new Date(authData.expiresAt);
    await this.storage.set('auth-data', authData);
    this.tokenExpiry();
    this.authObserver.next(true);
    this.authChecked = true;
    return true;
  }

  private async checkState(type: string): Promise<string> {
    return (await this.api.get('state/' + type)).msg;
  }

  public isAuthed(cb: (auth: boolean) => void): void {
    if (this.authChecked) {
      cb(this.authed);
    }

    this.authCBs.push(cb);
  }

  public async logout(): Promise<boolean> {
    if(this.authType === 'oidc') {
      await this.api.post('logout', {});
    }
    delete this.user;
    delete this.accessToken;
    delete this.expiresAt;
    this.storage.remove('auth-data');
    this.authObserver.next(false);
    this.router.navigateByUrl('/');
    return true;
  }

  private async tokenExpiry(): Promise<void> {
    const now = new Date();
    if (now.getTime() > this.expiresAt.getTime()) {
      await this.logout();
    } else {
      setTimeout(async () => {
        this.expiresAt = new Date((await this.api.post('token-expiry', {}) as any).expiresAt);
        this.tokenExpiry();
      }, (this.expiresAt.getTime() - now.getTime()));
    }
  }
}
